module.exports = __webpack_public_path__ + "img/2.64c30dc.svg";